(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initCurated(root) {
    if (!root || root.dataset.songsongTabsReady === 'true') return;
    root.dataset.songsongTabsReady = 'true';
    const tabs = Array.from(root.querySelectorAll('[data-tab-button]'));
    const panels = Array.from(root.querySelectorAll('[data-tab-panel]'));
    if (!tabs.length || !panels.length) return;

    const activate = (key, moveFocus = false) => {
      const activeTab = tabs.find((tab) => tab.dataset.tabButton === key) || tabs[0];
      tabs.forEach((tab) => {
        const selected = tab === activeTab;
        tab.classList.toggle('is-active', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      panels.forEach((panel) => { panel.hidden = panel.dataset.tabPanel !== activeTab.dataset.tabButton; });
      if (moveFocus) activeTab.focus();
      if (!window.Shopify?.designMode) {
        const url = new URL(window.location.href);
        url.searchParams.set('collection', activeTab.dataset.collectionHandle || activeTab.dataset.tabButton);
        window.history.replaceState({}, '', url);
      }
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.tabButton));
      tab.addEventListener('keydown', (event) => {
        let nextIndex;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = tabs.length - 1;
        if (nextIndex === undefined) return;
        event.preventDefault();
        activate(tabs[nextIndex].dataset.tabButton, true);
      });
    });

    const requestedHandle = new URL(window.location.href).searchParams.get('collection');
    const requestedTab = tabs.find((tab) => tab.dataset.collectionHandle === requestedHandle);
    activate(requestedTab?.dataset.tabButton || tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.tabButton || tabs[0].dataset.tabButton);
  }

  function initCarousel(root) {
    if (!root || root.dataset.songsongCarouselReady === 'true') return;
    root.dataset.songsongCarouselReady = 'true';
    const track = root.querySelector('[data-carousel-track]');
    const previous = root.querySelector('[data-carousel-previous]');
    const next = root.querySelector('[data-carousel-next]');
    if (!track || !previous || !next) return;
    const move = (direction) => track.scrollBy({ left: direction * Math.max(280, track.clientWidth * 0.82), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  }

  function init(scope = document) {
    scope.querySelectorAll('[data-songsong-curated]').forEach(initCurated);
    scope.querySelectorAll('[data-songsong-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const root = event.target.closest('[data-songsong-curated]');
    const tab = root?.querySelector(`[data-block-id="${event.detail.blockId}"]`);
    if (tab) tab.click();
  });
})();
